import React from 'react';
import useActiveJobs, { evaluateAssetMismatch } from '../../../hooks/useActiveJobs';
import './WrongAssetGuard.css';

const WrongAssetGuard = ({ propertyId, assetType, assetName }) => {
  const { jobs, loading } = useActiveJobs();
  if (loading || !propertyId || !assetType) return null;
  const result = evaluateAssetMismatch({ propertyId, assetType, activeJobs: jobs });
  if (!result.hasActiveJob || !result.mismatch) return null;

  return (
    <div className="cs-wag-banner" role="alert">
      <div className="cs-wag-icon" aria-hidden="true">!</div>
      <div className="cs-wag-body">
        <strong className="cs-wag-title">Wrong asset?</strong>
        <span className="cs-wag-text">
          {result.reason}{assetName ? ` (Opened: ${assetName})` : ''}
        </span>
      </div>
    </div>
  );
};

export default WrongAssetGuard;
